module.exports = __webpack_public_path__ + "img/Jarvis_Logo.76749e15.png";